export const SET_CSRF_TOKEN = 'UI/SET_CSRF_TOKEN'
export const SET_SETTINGS = 'UI/SET_SETTINGS'
